<template>
  <div class="app-input-label" :class="{ inline }">
    <span>
      <slot />
    </span>

    <small v-if="optional" v-html="optionalText" class="optional"></small>
  </div>
</template>

<script>
export default {
  name: 'AppInputLabel',

  props: {
    inline: {
      type: Boolean,
      default: false,
    },

    optional: {
      type: Boolean,
      default: false,
    },

    optionalText: {
      type: String,
      default: '(opcional)',
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;

.app-input-label {
  display: block;
  transition: color $defaultTransitionDuration;

  &.inline {
    display: inline;
  }

  > .optional {
    margin-left: 0.5ch;
    opacity: 0.5;
    font-style: italic;
    font-size: 75%;
  }
}
</style>
